var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{class:{ 'img-mod': _vm.moderation },attrs:{"src":_vm.url},on:{"load":_vm.load,"click":function($event){return _vm.$modal.show('image-modal', { image: _vm.url })}}})])}
var staticRenderFns = []

export { render, staticRenderFns }